import styled, { css } from 'styled-components'
import Flex from '../../Layout/Flex/Flex'
import { FontStyle } from '../../Core/Typography/Font/Font.styles'
import { SelectWrapperProps, SelectMainProps, SelectOptionsProps, SelectOptionProps, InputWrapperProps } from './types'
import { ScrollBarStyles } from 'src/components/Core/Styles/general-utilities'

export const InputWrapper = styled.div<InputWrapperProps>`
  position: relative;
  min-height: ${props => props.isForm ? '84px' : 'auto'};

  ${props => props.gridArea && css`
      grid-area: ${props.gridArea};
  `}

  ${props => props.marginInputWrapper && css`
    margin: ${props.marginInputWrapper};
  `}

  ${props => props.wrapperWidth && css`
    width: ${props.wrapperWidth};
  `}
  `

export const SelectWrapper = styled('div')<SelectWrapperProps>`
  position: relative;
  display: inline-block;
  width: ${props => props.fixWidth ? '240px' : (props.width || '100%')};
  min-width: ${props => props.minWidth > 80 ? props.minWidth : 80}px;
  max-width: 100vw;
  margin: ${props => props.selectMargin || '4px 0 8px 0'};
  user-select: none;
`

// eslint-disable-next-line
export const SelectMain = styled(Flex)<SelectMainProps | any>`
  height: 30px;
  padding: 0 8px 0 10px;
  background-color: ${props => props.theme.colors.main[(props.darkMode ? 'dark' : 'background') as string]};
  border: 1px solid ${props => props.removeBorder ? 'transparent' : props.isError ?
    props.theme.colors.main.error : props.theme.colors.shades.neutral[1]
};
  border-radius: 4px;
  cursor: pointer;

  svg {
    transform-origin: center center;
    transform: rotate(${props => props.isOpen ? '180' : '0'}deg);
    transition: transform 0.3s ease-in-out;
  }

  ${props => props.disabled && css`
    opacity: 0.5;
    cursor: not-allowed;
  `}

  ${props => props.readOnly && css`
    cursor: not-allowed;
    pointer-events: none;
    background-color: ${props => props.theme.colors.shades.neutral[1]};
    h5 {
      font-weight: bold;
      font-size: 12px;
      font-family: aktiv-grotesk, Arial, Helvetica, sans-serif;
      color: ${props => props.theme.colors.main.dark};
    }
  `}
`

export const SelectOptionsWrapper = styled('div')<SelectOptionsProps>`
  z-index: 10;
  position: absolute;
  display: ${props => props.isOpen ? 'block' : 'none'};
  margin-block-start: 8px;
  margin-block-end: 8px;
  width: ${props => props.extraSelectionWidth ? '160%' : '100%'};
  max-width: 100vw;
  max-height: 80vh;
  opacity: ${props => props.isOpen ? '1' : '0'};
  background-color: ${props => props.theme.colors.main.background};
  outline: ${props => props.removeOutline ? '0px' : '1px'} solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;
  transition: opacity 0.3s ease-in-out;
`

export const SelectOptions = styled('ul')<SelectOptionsProps>`
  margin-block-start: 0px;
  margin-block-end: 0px;
  list-style-type: none;
  padding-inline-start: 0px;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  max-height: 224px;
  border-radius: 4px;
  background-color: ${props => props.bgTransparent ? 'transparent' : props.theme.colors.main.background};

 ${ScrollBarStyles}
`

export const SelectOption = styled(Flex).attrs({ as: 'li' })<SelectOptionProps>`
  width: auto;
  height: 30px;
  padding: 0 8px;
  background-color: ${props => props.selected ? props.theme.colors.shades.neutral[1] : 'transparent'};

  &:hover {
    background-color: ${props => props.theme.colors.shades.neutral[1]};
  }

  ${props => props.multiple && css`
    height: auto;

    div {
      pointer-events: none;
      min-height: auto;
    }
  `}

  ${props => props.tab && css`
    padding-left: 24px;
  `}

  ${props => props.disabled && css`
    opacity: 0.5;
    cursor: not-allowed !important;
  `}
`

export const Placeholder = styled(FontStyle).attrs({ as: 'h5', tag: 'h5', ellipsis: true })<{placeholderAsValue?: boolean}>`
  color: ${props => props.placeholderAsValue ? props.theme.colors.main.dark : props.theme.colors.shades.neutral[2]};
  font-weight: normal;
`

export const ErrorLabel = styled(FontStyle).attrs({ as: 'h6', tag: 'h6', ellipsis: true, bold: true })`
  color: ${props => props.theme.colors.main.error};
`

export const FilterInputWrapper = styled(Flex)`
  position: relative;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.colors.shades.neutral[1]};
`

export const FilterInput = styled('input').attrs({
  type: 'text'
})`
  width: 100%;
  height: 30px;
  padding: 0 8px;
  border: 1px solid transparent;
  border-radius: 4px;
  ::placeholder {
    color: ${props => props.theme.colors.shades.neutral[2]};
    font-size: 14px;
  }

  &:focus {
    border: 1px solid transparent;
  }

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    background-color: ${props => props.theme.colors.shades.neutral[0]};
  }
`

export const FilterInputCloseWrapper = styled(Flex)`
  position: absolute;
  top: 0;
  right: 0;
  height: 32px;
  padding: 0 8px;
`

export const EmptyWrapper = styled(Flex)`
  padding: 16px;
`

export const GroupRadioButtonWrapper = styled.div`
  max-width: calc(100% - 30px);
  cursor: pointer;
`

export const GroupCheckboxWrapper = styled.div`
  max-width: 100%;
  cursor: pointer;
`

export const GroupOpenIconWrapper = styled(Flex)`
  width: 30px;
  height: 30px;
  cursor: pointer;
`
